import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Gjoba} from "../models/SearchService/gjoba.model";
import {Kindergarden} from "../models/SearchService/kindergarden.model";
import {map} from "rxjs/operators";

enum KindergardenType {
    Kopesht = 1,
    Cerdhe
}

@Injectable({
    providedIn: "root"
})
export class KindergardenHttpClientService {
    private readonly base = environment.backendBaseUrl;
    private readonly endpoint = "/api/kindergarden";
    private readonly fullPath = `${this.base}${this.endpoint}`;
    private readonly searchURL = `${this.fullPath}/search`;
    private readonly CCURL = `${this.fullPath}/start-cc`;
    private readonly walletURL = `${this.fullPath}/payment/web`;

    constructor(private http: HttpClient) {
    }

    search(firstName: string, lastName: string, type: KindergardenType) {
        const params = new HttpParams()
            .set("firstName", firstName)
            .append("lastName", lastName)
            .append("serviceid", String(type));

        return this.http.get<Kindergarden[]>(this.searchURL, {
            params
        }).pipe(
            map(kindergardens => {
                kindergardens.map(kindergarden => {
                    kindergarden.data = new Date(kindergarden.year, kindergarden.month - 1);
                });

                return kindergardens;
            })
        );
    }

    PayCC(invoice: any) {
        return this.http.post<any>(`${this.CCURL}`, invoice);
    }

    PayWallet(invoice: any) {
        return this.http.post<any>(`${this.walletURL}`, invoice);
    }
}
